import { c as _c } from "react/compiler-runtime";
import config from '@/config';
import { PageConfig } from '@/config/types';
import { useI18n } from '@/context/I18nProvider';
import Head from 'next/head';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
const SeoMetadata = () => {
  const $ = _c(36);
  const router = useRouter();
  const pathname = usePathname();
  const {
    t
  } = useI18n();
  let matchingPage;
  if ($[0] !== pathname) {
    let pages = config.pagesConfig;
    while (pages && pages.length) {
      matchingPage = pages.find(page => pathname.startsWith(page.path));
      if (!matchingPage || !matchingPage.subPages?.length) {
        break;
      }
      pages = matchingPage.subPages;
    }
    $[0] = pathname;
    $[1] = matchingPage;
  } else {
    matchingPage = $[1];
  }
  const matchingPage_0 = matchingPage;
  let t0;
  if ($[2] !== matchingPage_0 || $[3] !== t) {
    t0 = matchingPage_0 ? (t as (key: string) => string)(matchingPage_0.titleKey) : undefined;
    $[2] = matchingPage_0;
    $[3] = t;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const title = t0;
  const description = matchingPage_0?.description || config.metadata.description;
  const image = config.metadata.image;
  const siteTitle = config.metadata.title;
  const fullTitle = title ? `${title} · ${siteTitle}` : siteTitle;
  const canonicalUrl = `${config.metadata.url}${router.asPath}`;
  let t1;
  if ($[5] !== fullTitle) {
    t1 = <title>{fullTitle}</title>;
    $[5] = fullTitle;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <meta name="theme-color" content="#f4f1ea" />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== description) {
    t3 = <meta name="description" content={description} />;
    $[8] = description;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== canonicalUrl) {
    t4 = <link rel="canonical" href={canonicalUrl} />;
    $[10] = canonicalUrl;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== fullTitle) {
    t5 = <meta property="og:title" content={fullTitle} />;
    $[12] = fullTitle;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== description) {
    t6 = <meta property="og:description" content={description} />;
    $[14] = description;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== canonicalUrl) {
    t7 = <meta property="og:url" content={canonicalUrl} />;
    $[16] = canonicalUrl;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t10;
  let t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = image && <meta property="og:image" content={image} />;
    t9 = <meta property="og:type" content="website" />;
    t10 = <meta name="twitter:card" content="summary_large_image" />;
    $[18] = t10;
    $[19] = t8;
    $[20] = t9;
  } else {
    t10 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[21] !== fullTitle) {
    t11 = <meta name="twitter:title" content={fullTitle} />;
    $[21] = fullTitle;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== description) {
    t12 = <meta name="twitter:description" content={description} />;
    $[23] = description;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = image && <meta name="twitter:image" content={image} />;
    t14 = <link rel="icon" href="/favicon.ico" />;
    $[25] = t13;
    $[26] = t14;
  } else {
    t13 = $[25];
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t1 || $[28] !== t11 || $[29] !== t12 || $[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t15 = <Head>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</Head>;
    $[27] = t1;
    $[28] = t11;
    $[29] = t12;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export { SeoMetadata };
export default SeoMetadata;